import { render, staticRenderFns } from "./MonthlyAutoInvestBanner.vue?vue&type=template&id=24915da1&"
import script from "./MonthlyAutoInvestBanner.vue?vue&type=script&lang=js&"
export * from "./MonthlyAutoInvestBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports